module.exports = __webpack_public_path__ + "img/bj38.ba30b870.png";